import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { AtoZI18NextBackend } from '../i18nextbackend';
i18n.use(initReactI18next)
    .use(new AtoZI18NextBackend())
    .init({
    // To add new resources, see the AtoZI18NextBackend class
    resources: { 'en-US': AtoZI18NextBackend.ALL_ENGLISH_RESOURCES },
    load: 'currentOnly',
    partialBundledLanguages: true,
    fallbackLng: 'en-US',
    debug: false,
    ns: ['resources'],
    fallbackNS: 'resources',
    suspense: false,
    interpolation: {
        escapeValue: false // not needed for react!!
    },
    // react i18next special options (optional)
    // https://react.i18next.com/components/i18next-instance
    react: {
        bindI18n: 'languageChanged loaded',
        bindStore: 'added removed',
        nsMode: 'fallback'
    }
});
export var setupI18nextLanguage = function (lng) {
    i18n.changeLanguage(lng);
    return i18n;
};
export default i18n;
